<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Current DO Reference</label>
        <vs-input
          class="w-full"
          v-model="oldReference"
          placeholder="Enter current DO reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="oldReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <div class="vx-row mt-6" v-if="showPreview" style="display:flex;align-items:stretch;">
      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">DO Info</span>
          </div>
          <table style="width:100%">
            <tr><td style="padding:4px 0;font-weight:bold;width:40%;">DO Reference</td><td style="padding:4px 0;">{{ previewData.do_reference }}</td></tr>
            <tr><td style="padding:4px 0;font-weight:bold;">Status</td><td style="padding:4px 0;">{{ previewData.do_status }}</td></tr>
            <tr><td style="padding:4px 0;font-weight:bold;">TV Qty</td><td style="padding:4px 0;">{{ previewData.tv_qty }}</td></tr>
            <tr><td style="padding:4px 0;font-weight:bold;">Bracket Qty</td><td style="padding:4px 0;">{{ previewData.bracket_qty }}</td></tr>
            <tr><td style="padding:4px 0;font-weight:bold;">Bracket Base Qty</td><td style="padding:4px 0;">{{ previewData.bracket_base_qty }}</td></tr>
          </table>
        </vs-card>
      </div>

      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Records Akan Diupdate</span>
          </div>
          <table style="width:100%">
            <tr><td style="padding:4px 0;font-weight:bold;width:60%;">Delivery Orders</td><td style="padding:4px 0;">1 record</td></tr>
            <tr><td style="padding:4px 0;font-weight:bold;">Transport Orders</td><td style="padding:4px 0;">Reference terkait</td></tr>
            <tr><td style="padding:4px 0;font-weight:bold;">Inventories Transactions</td><td style="padding:4px 0;">{{ previewData.transactions_count }} record(s)</td></tr>
            <tr><td style="padding:4px 0;font-weight:bold;">AWB</td><td style="padding:4px 0;">Reference terkait</td></tr>
          </table>
        </vs-card>
      </div>
    </div>

    <div class="vx-row mt-6" v-if="showPreview">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label">New DO Reference</label>
        <vs-input
          class="w-full"
          v-model="newReference"
          placeholder="Enter new DO reference"
          @keyup.enter="submitForm"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button color="primary" class="btn mb-4 md:mb-0" @click="submitForm">Process</vs-button>
      </div>
    </div>

    <vs-popup title="Konfirmasi Change DO Reference" :active.sync="showConfirmModal" v-if="previewData">
      <p style="margin-bottom:12px;">Apakah kamu yakin ingin memperbarui DO reference?</p>
      <table style="width:100%;margin-bottom:16px;">
        <tr><td style="padding:4px 0;font-weight:bold;width:40%;">Current Reference</td><td style="padding:4px 0;">{{ oldReference }}</td></tr>
        <tr><td style="padding:4px 0;font-weight:bold;">New Reference</td><td style="padding:4px 0;">{{ newReference }}</td></tr>
      </table>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="primary" class="btn" @click="confirmUpdate">Ya, Update</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "ChangeDoReference",
  data() {
    return {
      oldReference: "",
      newReference: "",
      previewData: null,
      showPreview: false,
      showConfirmModal: false,
    };
  },
  methods: {
    searchPreview() {
      if (this.oldReference == "") {
        this.$vs.notify({ color: "danger", title: "Error", text: "Old DO Reference is required" });
        return false;
      }
      this.$emit("loading", true);
      this.showPreview = false;
      this.$http.post("support/outbound/deliveryorder/preview", { do_reference: this.oldReference })
        .then((res) => {
          this.$emit("loading", false);
          this.previewData = res.data.data;
          this.showPreview = true;
          this.newReference = "";
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
    submitForm() {
      if (this.newReference == "") {
        this.$vs.notify({ color: "danger", title: "Error", text: "New DO Reference is required" });
        return false;
      }
      if (this.oldReference === this.newReference) {
        this.$vs.notify({ color: "danger", title: "Error", text: "Old and new reference are the same" });
        return false;
      }
      this.showConfirmModal = true;
    },
    confirmUpdate() {
      this.showConfirmModal = false;
      this.$emit("loading", true);
      this.$http.post("support/outbound/change-do-reference", {
        old_reference: this.oldReference,
        new_reference: this.newReference,
      })
        .then((res) => {
          this.$emit("loading", false);
          const data = res.data.data;
          this.$vs.notify({ color: "success", title: "Success", iconPack: "feather", icon: "icon-check", text: `DO reference "${data.old_reference}" berhasil diperbarui menjadi "${data.new_reference}".` });
          this.oldReference = "";
          this.newReference = "";
          this.previewData = null;
          this.showPreview = false;
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
  },
};
</script>
